import { bool } from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import PdpNameSpaceReducerCreator from 'yoda-site-components/lib/reducers/PdpNameSpaceReducerCreator';
import selectLazy from 'yoda-site-components/lib/lazy/selectors/selectLazy';
import MiniPDPReducer from 'yoda-site-components/lib/reducers/MiniPDPReducer';
import MyAlertsReducer from 'yoda-site-components/lib/reducers/MyAlertsReducer';
import MyAlertsSaga from 'yoda-site-components/lib/sagas/MyAlertsSaga';
import withReducerSaga from 'yoda-site-components/lib/hoc/ReducerRegistry/withReducerSaga';
import { timeout } from 'yoda-site-components/lib/lazy/lazyConstants';
import MiniPDPErrorSliderConnected from '../MiniPDPErrorSlider/MiniPDPErrorSlider';
import EventListener from './EventListener';

/* istanbul ignore next */
const MiniPDPUniversal = universal(
    universalImport({
        chunkName: () => 'MiniPDPInterstitial',
        path: () => path.join(__dirname, './MiniPDPInterstitial'),
        resolve: () => require.resolveWeak('./MiniPDPInterstitial'),
        load: () =>
            Promise.all([
                import(/* webpackChunkName: "MiniPDPInterstitial" */ './MiniPDPInterstitial'),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
        error: <MiniPDPErrorSliderConnected persistError logError />,
        timeout,
    }
);
export class MiniPDPInterstitialAsync extends PureComponent {
    static propTypes = {
        miniPDP: bool,
    };

    static defaultProps = {
        miniPDP: false,
    };

    render() {
        if (this.props.miniPDP) {
            return (
                <>
                    <MiniPDPUniversal />
                    <EventListener />
                </>
            );
        }

        return <EventListener />;
    }
}

const mapStateToProps = (state) => ({
    miniPDP: selectLazy(state).miniPDP,
});

export default compose(
    withReducerSaga(
        [MiniPDPReducer, PdpNameSpaceReducerCreator(MyAlertsReducer, true, 'miniPdpMyAlerts')],
        [MyAlertsSaga]
    ),
    connect(mapStateToProps)
)(MiniPDPInterstitialAsync);
